import {Component, OnInit} from '@angular/core';
import {
  IUserBrandingRepository
} from '../../../domain/user-branding-repository';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {UserBrandingSetting} from '../../../domain/user-branding-setting';
import * as console from 'node:console';

@Component({
  selector: 'evrideo-user-branding-edit',

  templateUrl: './user-branding-edit.component.html',
  styleUrl: './user-branding-edit.component.scss'
})
export class UserBrandingEditComponent implements OnInit {
  public vm: UserBrandingSetting;


constructor(
  private _userBrandingRepository: IUserBrandingRepository,
  private _router: Router,
  private _route: ActivatedRoute,
) {
}

  ngOnInit(): void {

    this._route.params.subscribe(async (params: Params) => {
      if (!!params["domainNameAsUid"]) {
        this.vm = (await this._userBrandingRepository.getAll()).find(s => s.domainNameAsUid.trim().toLowerCase() === params["domainNameAsUid"].toLowerCase().trim());
      }
    });
    }


  async onSaveClicked() {
    window.console.log("UserBrandingEditComponent->onSaveClicked", this.vm);
    await this._userBrandingRepository.upsert(this.vm);
    await this._router.navigate(["/user-branding"]);
  }

  async onCancelClicked() {
    await this._router.navigate(["/user-branding"]);
  }
}
